<template>
    <article @click="$emit('close')" v-if="visible" class="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 cursor-pointer">
        <div @click.stop class="pdf-container bg-white rounded-lg shadow-lg h-[90%] w-11/12 md:w-3/4 lg:w-[70%] flex flex-col cursor-auto">
            <div class="flex justify-between items-center px-5 py-3 border-b bg-gray-50 rounded-lg">
                <h2 class="text-lg font-semibold text-gray-800 truncate">{{ $root.getLangText({'en': 'Pdf Viewer', ru: 'Просмотр PDF-файла'}) }}</h2>
                <div class="flex items-center space-x-2">
                    <button @click="openInNewTab" class="p-2 rounded hover:bg-gray-200 text-gray-600 hover:text-black" title="Open in new tab">
                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 3h6v6"/><path d="M10 14 21 3"/><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"/></svg>
                    </button>
                    <button @click="toggleFullScreen" class="p-2 rounded hover:bg-gray-200 text-gray-600 hover:text-black" title="Toggle full screen">
                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="m15 15 6 6"/><path d="m15 9 6-6"/><path d="M21 16v5h-5"/><path d="M21 8V3h-5"/><path d="M3 16v5h5"/><path d="m3 21 6-6"/><path d="M3 8V3h5"/><path d="M9 9 3 3"/></svg>
                    </button>
                    <button @click="$emit('close')" class="p-2 rounded hover:bg-gray-200 text-gray-600 hover:text-black" title="Close">
                        <svg class="w-5 h-5" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M18 6 6 18"/><path d="m6 6 12 12"/></svg>
                    </button>
                </div>
            </div>

            <div class="flex-1">
                <iframe class="w-full h-full" :src="`${url}#zoom=100`" frameborder="0"></iframe>
            </div>
        </div>
    </article>
</template>

<script>
export default {
    name: 'PdfModal',

    props: {
        visible: {
            type: Boolean,
            default: false
        },
        url: {
            type: [String, null],
            // required: true,
            default: null
        },
        title: {
            type: String,
            default: 'Pdf Viewer'
        },
        baseUrl: {
            type: String,
            default: process.env.VUE_APP_IMG_URL
        }
    },

    methods: {
        toggleFullScreen() {
            const el = this.$el.querySelector('.pdf-container')
            if (!document.fullscreenElement) {
                if (el.requestFullscreen) {
                    el.requestFullscreen()
                } else if (el.webkitRequestFullscreen) { // Safari
                    el.webkitRequestFullscreen()
                } else if (el.msRequestFullscreen) { // IE11
                    el.msRequestFullscreen()
                }
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                } else if (document.webkitExitFullscreen) {
                    document.webkitExitFullscreen()
                } else if (document.msExitFullscreen) {
                    document.msExitFullscreen()
                }
            }
        },

        openInNewTab() {
            if(!this.url) return null
            window.open(this.url, '_blank')
        }
    }
}
</script>